import { render, staticRenderFns } from "./SettlementGoogleSheetsConfigView.vue?vue&type=template&id=2ca05103&scoped=true"
import script from "./SettlementGoogleSheetsConfigView.vue?vue&type=script&lang=js"
export * from "./SettlementGoogleSheetsConfigView.vue?vue&type=script&lang=js"
import style0 from "./SettlementGoogleSheetsConfigView.vue?vue&type=style&index=0&id=2ca05103&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca05103",
  null
  
)

export default component.exports